import { SearchOutlined } from '@ant-design/icons';
import { Col, Form, FormInstance, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GetOwneds from '~/@core/application/useCases/rfidReports/inventory/getOwneds';
import GetProducers from '~/@core/application/useCases/rfidReports/inventory/getProducers';
import DefaultPaginated from '~/@core/domain/@shared/DefaultPaginated';
import Owned from '~/@core/domain/model/rfidReports/Owned';
import Producer from '~/@core/domain/model/rfidReports/Producer';
import FormFilterTextModel, {
  MapFormToFilter
} from '~/@core/domain/ui/forms/FormFilterTextModel';
import DefaultRow from '~/components/bosons/DefaultRow';
import SearchButton from '~/components/Buttons/SearchButton';
import { globalContext } from '~/context/GlobalContext';
import useOwnedStore from '~/zustand/rfidReports/inventory/owned-state';
import useProducerStore from '~/zustand/rfidReports/inventory/producer-state';
import { SearchButtonDiv } from '../Dones/FormFilterInventoryDone.styled';
import { PermissionNames } from '~/constants/permissionNames';

const { Option } = Select;

interface Props {
  form: FormInstance<FormFilterTextModel>;
}
export default function FormFilterInventoryOwned(props: Props) {
  const { form } = props;
  const { t } = useTranslation();
  const {
    ownedPagination,
    addOwneds,
    handleOwnedPagination,
    setIsLoadingOwned
  } = useOwnedStore();

  const { producers, addProducers } = useProducerStore();

  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  useEffect(() => {
    form.setFieldsValue({
      txtFilter: ''
    });
  }, [form]);

  useEffect(() => {
    const permissionName = PermissionNames.RfidReports.MenuInventory;
    const getProducers = new GetProducers(permissionName);

    handlePromiseUseCase<Producer[], AxiosError>(
      getProducers.execute(),
      producerOut => {
        addProducers(producerOut);
      },
      error => {
        activeAlert({
          message: JSON.stringify(
            error.response?.data
              ? error.response?.data
              : 'Houve um erro inesperado!'
          ),
          type: 'error',
          timeout: 5000
        });
      }
    );
  }, []);

  const onSubmitOwned = useCallback(
    (formValues: FormFilterTextModel) => {
      const filterOwned = MapFormToFilter.toFilter(formValues, {
        pageSize: ownedPagination.pageSize,
        pageNumber: ownedPagination.current
      });

      const getOwneds = new GetOwneds();
      setIsLoadingOwned();

      handlePromiseUseCase<DefaultPaginated<Owned[]>, AxiosError>(
        getOwneds.execute(filterOwned),
        ownedsOut => {
          addOwneds(ownedsOut.results);
          handleOwnedPagination({
            ...ownedPagination,
            total: ownedsOut.totalCount
          });
          setIsLoadingOwned();
        },
        error => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
          setIsLoadingOwned();
        }
      );
    },
    [
      activeAlert,
      addOwneds,
      handleOwnedPagination,
      handlePromiseUseCase,
      ownedPagination,
      setIsLoadingOwned
    ]
  );

  return (
    <Form layout="vertical" form={form} onFinish={onSubmitOwned}>
      <DefaultRow>
        <Col lg={6}>
          <Form.Item
            name="txtFilter"
            label="Sitio: "
            rules={[{ required: true }]}
          >
            <Select allowClear placeholder="Selecione">
              {producers.map(producer => (
                <Option value={producer.account}>
                  {producer.account} - {producer.tradingName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col lg={3}>
          <SearchButtonDiv>
            <SearchButton
              htmlType="submit"
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => {}}
            />
          </SearchButtonDiv>
        </Col>
      </DefaultRow>
    </Form>
  );
}
